const STORAGE_KEY = 'bhima-pos.daily-sale-count';

function todayKey(date = new Date()) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

function loadState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { date: '', count: 0 };
  } catch {
    return { date: '', count: 0 };
  }
}

function saveState(state) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

/** Format: DD + M + YY + NNN — e.g. 31826001 for 31 Aug 2026, sale #1 */
export function formatPosCustomerNumber(date, count) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1);
  const year = String(date.getFullYear()).slice(-2);
  const seq = String(count).padStart(3, '0');
  return `${day}${month}${year}${seq}`;
}

/** Do not reuse a sequence the server already issued today. */
export function ensurePosCustomerCountAtLeast(count, date = new Date()) {
  const state = loadState();
  const key = todayKey(date);
  const current = state.date === key ? state.count : 0;
  const floor = Math.max(0, Number(count) || 0);
  if (state.date === key && current >= floor) return;
  saveState({ date: key, count: Math.max(current, floor) });
}

/** Reserve the next customer number for today (persists in localStorage). */
export function allocatePosCustomerNumber(date = new Date()) {
  const state = loadState();
  const key = todayKey(date);
  const nextCount = (state.date === key ? state.count : 0) + 1;
  saveState({ date: key, count: nextCount });
  return formatPosCustomerNumber(date, nextCount);
}
